var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C19.3989 0 25 5.60107 25 12.5C25 19.3989 19.3989 25 12.5 25C5.60107 25 0 19.3989 0 12.5C0 5.60107 5.60107 0 12.5 0ZM10.2983 19.1483C15.8297 19.1483 18.8542 14.5648 18.8542 10.5925C18.8542 10.4616 18.8542 10.3306 18.8479 10.2059C19.4341 9.78184 19.9455 9.25176 20.3508 8.64687C19.8145 8.88384 19.2345 9.046 18.6234 9.1208C19.247 8.74663 19.7209 8.16045 19.9455 7.45581C19.3655 7.79878 18.7232 8.04819 18.0372 8.1854C17.4884 7.59922 16.7089 7.23755 15.8421 7.23755C14.1833 7.23755 12.8364 8.58452 12.8364 10.2433C12.8364 10.4803 12.8613 10.711 12.9174 10.9292C10.4168 10.8045 8.20298 9.60723 6.71885 7.78628C6.46314 8.22905 6.31348 8.74663 6.31348 9.29541C6.31348 10.3368 6.84355 11.2598 7.65425 11.796C7.16157 11.7836 6.7001 11.6464 6.29478 11.4219V11.4593C6.29478 12.9186 7.32993 14.1283 8.70811 14.409C8.45869 14.4775 8.19053 14.515 7.91616 14.515C7.7228 14.515 7.53574 14.4963 7.34868 14.4588C7.72905 15.6562 8.83906 16.523 10.1549 16.5479C9.12593 17.3524 7.82886 17.8326 6.41948 17.8326C6.17627 17.8326 5.93931 17.8201 5.70234 17.7889C7.01816 18.6495 8.6021 19.1483 10.2983 19.1483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.59d54d32.svg";
export { ForwardRef as ReactComponent };